import {
  Button,
  Dialog,
  Loader,
  Modal,
  Select,
  Spinner,
} from '@oliasoft-open-source/react-ui-library';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';

type NodesModalProps = {
  visible: boolean
  getAllNodes: Function,
  onConfirmNodeSelect: Function,
  onClose: () => void,
  isNodesLoading: boolean,
  nodes: any
};

type TNode = { name: string, nodeid: string };
type TNodeOptions = { label: string, value: string };

const prepareOptions = (nodes: TNode[]): TNodeOptions[] => {
  return nodes?.map(node => ({ label: node.name, value: node.nodeid }));
};

export const NodesModal = ({
  visible,
  onClose,
  onConfirmNodeSelect,
  getAllNodes,
  isNodesLoading,
  nodes,
}: NodesModalProps) => {
  const nodesOptions = prepareOptions(nodes);
  const [selectedNodeId, setSelectedNodes] = useState<string | null>(null);
  const selectedOption = nodesOptions.find(n => n.value === selectedNodeId);

  const { t } = useTranslation();

  useEffect(() => {
    getAllNodes();
  }, []);

  const handleConfirmNodeSelect = () => {
    onConfirmNodeSelect(selectedNodeId);
    onClose();
  };

  return (
    <Modal visible={visible} centered onEscape={onClose}>
      <Dialog
        dialog={{
          scroll: true,
          heading: t(translations.importExport_selectCatalogue),
          content: isNodesLoading
            ? <Loader text={`${t(translations.importExport_loadingCatalogues)}`} width="100%" height="30px" theme="light"><Spinner dark /></Loader>
            : (
              <Select
                onChange={(e: any) => {
                  setSelectedNodes(e.target.value);
                }}
                value={selectedOption}
                options={nodesOptions}
                placeholder={t(translations.importExport_selectCatalogue)}
              />
            ),
          footer: (
            <>
              <Button label={t(translations.importExport_Select)} onClick={handleConfirmNodeSelect} disabled={isNodesLoading || !selectedOption} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
          width: '30%',
        }}
      />
    </Modal>
  );
};